import { useEffect } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";
import {useTranslation} from "react-i18next";

const LegendControl = ({title, incidentLegend}) => {
    const map = useMap();
    const {t} = useTranslation(['components']);

    useEffect(() => {
        const legend = L.control({ position: "bottomright" });

        legend.onAdd = function () {
            const div = L.DomUtil.create("div", "info legend");
            div.innerHTML = `<h4>${title ?? t('legendControl.title')}</h4>`;
            incidentLegend.forEach(item => {
                div.innerHTML += `
                    <i style="background: ${item.color}"></i> ${item.description}<br>
                `;
            });
            return div;
        };

        legend.addTo(map);

        return () => {
            legend.remove();
        };
    }, [map, t]);

    return null;
};

export default LegendControl;